import { useLayoutEffect } from 'react';
import { useDispatch } from 'react-redux';

import { restoreOwnerSession } from '@main/features/auth/ownerAuthSlice';
import { restoreCrmSession } from '@crm/features/auth/crmAuthSlice';

/**
 * Проверяет httpOnly-сессии при старте (js-cookie их не читает).
 * Должен быть внутри Router + Provider.
 */
export function AuthSessionSync() {
  const dispatch = useDispatch();
  useLayoutEffect(() => {
    dispatch(restoreOwnerSession());
    dispatch(restoreCrmSession());
  }, [dispatch]);
  return null;
}
